import ModalEditQuantityRoom from './ModalEditQuantityRoom.container';

export default ModalEditQuantityRoom;
